const baseurl = "https://whiskeymapper.com/api";
export {baseurl}